<template>
    <div>
        <!-- Main Content -->
        <div class="container-fluid">
            <!-- Header Menu -->
            <div class="row">
                <div class="col-sm-12">
                    <h6 class="h2 d-inline-block text-dark mt-2 mb-0">
                        <i :class="'ni '+PageIcon+' mr-1'"></i>{{PageTitle}}
                    </h6>

                    <base-button class="ml-2 mb-3" size="sm" type="info" @click="NewItem()">
                        <i class="fa fa-plus-circle"></i>{{MenuNewLabel}}
                    </base-button>
                </div>
            </div>

            <!-- Table Data -->
            <div class="row mt-2">
                <div class="col-sm-12">
                    <datagrid
                        v-bind:showscoll="true"
                        v-bind:header_nowarp="true"
                        v-bind:showfilter="true"
                        v-bind:rowdbclick_enable="false"
                        v-bind:showPagination="true"
                        v-bind:ShowSort="true"
                        v-bind:HeaderStick="TBHeaderStick"
                        v-bind:isBusy="TBBusy"
                        v-bind:perPage="TBRowPerPage"
                        v-bind:datas="Items"
                        v-bind:cols="Fields"
                    />
                </div>
            </div>
        </div>

        <!-- Modal -->
        <modal :show="ModalEditOpen" size="md">
            <div class="container-fluid">
                <h4 class="text-dark mb-1">{{ModalEditTitle}} Add/Edit</h4>

                <div class="form-group row">
                    <label class="col-md-12 col-form-label form-control-label pull-right">Churh Name</label>
                    <div class="col-md-12">
                        <base-input v-model="EditItem.churchname"></base-input>
                    </div>
                </div>

                <base-input label="Address">
                    <textarea class="form-control"  v-model="EditItem.addr" rows="3"></textarea>
                </base-input>

                <div class="form-group row">
                    <label class="col-md-2 col-form-label form-control-label pull-right">Index</label>
                    <div class="col-md-10">
                        <base-input type="number" v-model.number="EditItem.idx"></base-input>
                    </div>
                </div>

                <div class="row mt-2 justify-content-end">
                    <base-button @click="SaveItem()" type="success"><i class="fa fa-save"></i> Save</base-button>
                    <base-button @click="CancelSaveItem()" type="dark"><i class="fa fa-times"></i> Close</base-button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import BaseButton from '../components/BaseButton.vue';
import datagrid from "../component_thaicma/DataGrid.vue";
import ChurchService from "../services/ChurchService.vue";

export default {
    components: {
        datagrid,
        BaseButton
    },
    data(){
        return{
            PageTitle: "Church Manage",
            PageIcon: "ni-single-02 text-success",            
            MenuNewLabel: "New Church",
            TBHeaderStick: "70vh",
            TBBusy: false,
            TBRowPerPage: 100,
            Items:[],
            Fields:[
                { key: "church_id", label: "CMD" },
                { key: "churchname", label: "Church Name" },
                { key: "addr", label: "Address" },
                { key: "idx", label: "Index" },
            ],
            EditItem:{
                churchname:"",
                addr: "",
                idx:1
            },
            KeyItem: "church_id",
            ModalEditTitle: "Church",
            ModalEditOpen: false,
            SubKeys:[
                "churchname"
            ]
        }
    },
    methods:{
        GetItemLists(){
            ChurchService.ChurchGets()
                .then(res => {
                    this.Items = [];
                    this.Items = res.data;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        NewItem(){
            this.EditItem ={
                churchname:"",
                addr: "",
                idx:1
            };
            if(this.Items.length > 0){
                let LastIdx = Math.max.apply(Math, this.Items.map(function(f) { return f.idx; }));
                this.EditItem.idx = LastIdx + 1;
            }
            this.ModalEditOpen = true;
        },
        ValidateData(){
            let IsOK = false;
            let Notice = "";

            if(this.EditItem.churchname == "")
                Notice += "Please insert <b class='text-danger'>Churh Name</b><br/>";
            
            if(this.EditItem.idx <= 0)
                Notice += "Index must greater than <b class='text-danger'>Zero</b>"

            if(Notice != ""){
                this.$swal({
                    title: this.ModalEditTitle +" invalid data!!!",
                    html: Notice,
                    icon: "warning"
                })
                IsOK = false;
            }
            else{
                IsOK = true;
            }

            return IsOK;
        },
        SaveItem(){
            let IsOK = this.ValidateData();

            if(IsOK == true){
                if(this.EditItem[this.KeyItem] == null || this.EditItem[this.KeyItem] == ""){
                    ChurchService.ChurchAdd(this.EditItem)
                        .then(res => {
                            this.$swal({
                                title: "Save "+this.ModalEditTitle,
                                html: res.data,
                                icon: "success"
                            });
                            this.ModalEditOpen = false;
                            this.GetItemLists();
                        })
                        .catch(err => {
                            this.$swal({
                                title: "Save "+this.ModalEditTitle+" Error!!!",
                                html: err,
                                icon: "error"
                            });
                        });
                }
                else{
                    ChurchService.ChurchUpdate(this.EditItem)
                        .then(res => {
                            this.$swal({
                                title: "Update "+this.ModalEditTitle,
                                html: res.data,
                                icon: "success"
                            });
                            this.ModalEditOpen = false;
                            this.GetItemLists();
                        })
                        .catch(err => {
                            this.$swal({
                                title: "Update "+this.ModalEditTitle+" Error!!!",
                                html: err,
                                icon: "error"
                            });
                        });
                }
            }
        },
        CancelSaveItem(){
            this.ModalEditOpen = false;
        },
        DeleteItem(ItemKey){
            ChurchService.ChurchDelete(ItemKey)
                        .then(res => {
                            this.$swal({
                                title: "Delete "+this.ModalEditTitle,
                                html: res.data,
                                icon: "success"
                            });
                            this.GetItemLists();
                        })
                        .catch(err => {
                            this.$swal({
                                title: "Delete "+this.ModalEditTitle+" Error!!!",
                                html: err,
                                icon: "error"
                            });
                        });
        },
        GridEditData(EditData){
            this.EditItem = JSON.parse(JSON.stringify(EditData));
            this.ModalEditOpen = true;
        },
        GridDeleteData(DeleteItem){
            let subdata = "";
            for(let i = 0; i < this.SubKeys.length; i++){
                let sk = this.SubKeys[i];
                subdata += " "+DeleteItem[sk];
            }

            this.$swal({
                title: this.ModalEditTitle + ' Delete',
                html: '<h5>Are you sure to delete<b class="text-danger">'+subdata+'</b>?</h5>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#f5365c',
                cancelButtonColor: '#000',
                confirmButtonText: '<i class="fa fa-trash"> Delete</i>'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    let ItemKey = DeleteItem[this.KeyItem];
                    this.DeleteItem(ItemKey);
                }
            });
        }
    },
    mounted(){
        this.GetItemLists();
    }
}
</script>

<style scoped>

</style>